// extracted by mini-css-extract-plugin
export default {"largeThumbnail":"ksppXPb3bWAcDUNXtbvq","thumbnail":"Y7ZqUaEikWULcEJYXxTH","list":"TNqNczCkyR1OG1VSAZqb","thumbnailsClasses":"xDzogyzrzqGZLtKCTB6g"};